module.exports = __webpack_public_path__ + "img/lnk-dash.cbc08a44.svg";